import Select from '@storeblocks/select';
import { useField } from 'formik';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { nameof } from '@/util/nameof';

import { useCountriesAsSelectOption } from '../hooks/useCountriesAsSelectOption';
import { FormValues } from '../types/FormValues';

export const CitizenshipSelect: FC = () => {
  const texts = useTexts();

  const [field, meta] = useField<string>(nameof<FormValues>('citizenship'));

  const countryOptions = useCountriesAsSelectOption();

  return (
    <Select
      {...field}
      id="citizenship"
      label={texts.orders.signatureRight.citizenship.other.title}
      hint={texts.orders.signatureRight.pep.citizenship.description}
      options={countryOptions}
      placeholder={texts.orders.signatureRight.pep.citizenship.placeholder}
      alertMessageType={meta.touched && meta.error ? 'error' : undefined}
      alertMessage={meta.error}
      fluid
    />
  );
};
